import { defineComponent as r, computed as o, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as n, createCommentVNode as d, normalizeStyle as f, createStaticVNode as v } from "vue";
const p = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "01a8e481-ae8b-4c7b-8fef-21838a5cecbc" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#01a8e481-ae8b-4c7b-8fef-21838a5cecbc)" }, u = { key: 0 }, k = /* @__PURE__ */ v('<path fill="#0052b4" d="M0 0h232l64 256-64 256H0Z"></path><path fill="#d80027" d="M232 0h280v256l-140 64-140-64Z"></path><path fill="#eee" d="M232 256h280v256H232Z"></path><path fill="#0052b4" d="M0 0h232v512H0z"></path><path fill="#eee" d="m91 294 65-47H76l65 47-25-76z"></path><path fill="#ffda44" d="M24 224h40v64H24zm144 0h40v64h-40zM64 92v16H24v32h40v-16h104v16h40v-32h-40V92H64zm0 328v-16H24v-32h40v16h104v-16h40v32h-40v16z"></path>', 6), g = { fill: "none" }, b = ["r"], w = /* @__PURE__ */ r({
  __name: "us-nc",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(h) {
    const e = h, l = o(() => 512 + 2 * e.strokeWidth), a = o(() => -e.strokeWidth), i = o(() => 256 + e.strokeWidth / 2);
    return (x, z) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", _, [
        e.flagName ? (c(), s("title", u, n(e.flagName), 1)) : d("", !0),
        k
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, p));
  }
});
export {
  w as default
};
//# sourceMappingURL=us-nc-b2b82ba3.js.map
